module.exports = __webpack_public_path__ + "static/media/michelle_2021.1e9f2ebd.jpg";